import { render } from "./AddressPopup.vue?vue&type=template&id=7015898d&scoped=true"
import script from "./AddressPopup.vue?vue&type=script&lang=js"
export * from "./AddressPopup.vue?vue&type=script&lang=js"

import "./AddressPopup.vue?vue&type=style&index=0&id=7015898d&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7015898d"]])

export default __exports__